import React, { Component } from 'react'
import _ from 'lodash'

import CustomSnackbar from 'components/Snackbar';

import { Get, Post, Delete } from 'utils/axios'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {

    state = {
      showSnackbar:false,
      snackbarMessage: '',
      snackbarType: '',
      onCloseSnackbar: () => {},

      loading: false,
      loadingCount: 0,
      showSubmissionModal: false,

      kpi: [],
      selectedKPI: {}
    }

    load = param => {
      this.setState((prevState) => {
        const newCount = param ? prevState.loadingCount + 1 : prevState.loadingCount - 1
        return {
          loading: newCount > 0,
          loadingCount: newCount
        }
      })
    }
    requestError = error => this.setState({
      showSnackbar: true,
      snackbarType: 'error',
      onCloseSnackbar: () => this.setState({ showSnackbar: false }),
      snackbarMessage: error
    })
    requestSuccess = ( success, callback ) => this.setState({
      showSnackbar: true,
      snackbarType: 'success',
      onCloseSnackbar: () => {
        this.setState({ showSnackbar: false })
        callback && callback()
      },
      snackbarMessage: success
    })
    onChangeKPIHOC = ( val, context ) => this.setState({ [ context ]: val })

    getKPIs = kpis => Get(
      `/kpi-getKPIs?kpis=${ JSON.stringify( kpis ) }`,
      this.getKPIsSuccess,
      this.getKPIsError,
      this.load
    )
    getKPIsSuccess = payload => this.setState({ kpi: _.orderBy(payload.data.kpi, ['index_id', 'kpi_id'], ['asc', 'asc']) })
    getKPIsError = error => this.requestError( error )

    putKPISubmission = dataToSubmit => Post(
      `/kpi-kpiSubmission`,
      dataToSubmit,
      this.putKPISubmissionSuccess,
      this.putKPISubmissionError,
      this.load
    )
    putKPISubmissionSuccess = payload => {
      this.requestSuccess( payload.data.message )
      this.setState({ showSubmissionModal: false })
      this.props.getProjectDetail( this.props.projectDetail.project_id )
    }
    putKPISubmissionError = error => this.requestError( error )

    render = () => {
      return (
        <>
          <WrappedComponent
            { ...this.props } 
            { ...this.state }
            onLoadKPI={ this.state.loading }

            getKPIs={ this.getKPIs }
            putKPISubmission={ this.putKPISubmission }
            onChangeKPIHOC={ this.onChangeKPIHOC }/>
          <CustomSnackbar
            open={ this.state.showSnackbar }
            message={ this.state.snackbarMessage }
            onClick={ this.state.onCloseSnackbar }
            type={ this.state.snackbarType }
          />
        </>
      )
    }
  }
  return WithHOC;
}

export default HOC